export const quoteLocationType = {
  origin: "Origin",
  destination: "Destination",
};
